import { render } from "./elem-icon.vue?vue&type=template&id=77eb2fdf&ts=true"
import script from "./elem-icon.vue?vue&type=script&lang=ts"
export * from "./elem-icon.vue?vue&type=script&lang=ts"

import "./elem-icon.vue?vue&type=style&index=0&id=77eb2fdf&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__